// extracted by mini-css-extract-plugin
export default {"watermark":"Watermark_watermark__7Q2f4","logo":"Watermark_logo__iLKUB"};